/******/ (() => { // webpackBootstrap
/******/ 	"use strict";

const __initWithSharedSwiper = () => {
  const { Swiper, A11y, Autoplay, EffectFade, Keyboard, Mousewheel, Navigation, Pagination, Scrollbar } = window.T3SwiperRuntime || {};
  if (!Swiper) return;
;// ./src/javascripts/webcomponents/grid-slider.js



class GridSlider extends HTMLElement {
  constructor() {
    super();
    this._updatePropertiesFromDataset();
  }

  connectedCallback() {
    this._initSlidesPerView();
    this._attachEventListeners();
    this.init();
  }

  _updatePropertiesFromDataset() {
    this.slideCount = this.querySelectorAll('.swiper-slide').length;
    this.slidesPerViewDesktop = parseFloat(this.dataset.slidesPerViewDesktop) || 4;
    if (!this.dataset.slidesPerViewDesktopFixed == 'true') {
      this.slidesPerViewDesktop = this.slidesPerViewDesktop + 0.5;
    }
    this.slidesPerViewMobile = parseFloat(this.dataset.slidesPerViewMobile) || 2;
    if (!this.dataset.slidesPerViewMobileFixed == 'true') {
      this.slidesPerViewMobile = this.slidesPerViewMobile + 0.5;
    }
    this.slidesPerViewTablet = parseFloat(this.dataset.slidesPerViewTablet) || 3.5;

    this.productsToShow = parseInt(this.dataset.productLimit, 10) || 4;
  }

  _attachEventListeners() {
    ['recentlyViewed:loaded', 'recommendations:loaded'].forEach(event => {
      document.addEventListener(event, () => {
        this._updatePropertiesFromDataset();
        this.slideCount = this.querySelectorAll('.swiper-slide').length;
        this._initSlidesPerView();
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
        }
        this.init();
      });
    });

    if (window.Shopify.designMode) {
      window.addEventListener('resize', () => {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
        }
        this.init();
      });
    }
  }

  _initSlidesPerView() {
    if (this.dataset.slidesPerViewExact == 'true') return;

    this.slidesPerViewMobile == 1 ? this.slidesPerViewMobile = this.slidesPerViewMobile + 0.08 : this.slidesPerViewMobile = this.slidesPerViewMobile - 1 + 0.5;

    // If the number of slides is less than the number of slides per view, set slides per view to auto
    // If the slides per view is greater than the number of products to show, set slides per view to auto
    if (this.slideCount <= this.slidesPerViewMobile || this.slidesPerViewMobile >= this.productsToShow) this.slidesPerViewMobile = 'auto';
    if (this.slideCount <= this.slidesPerViewTablet || this.slidesPerViewTablet >= this.productsToShow) this.slidesPerViewTablet = 'auto';
    //if (this.slideCount <= this.slidesPerViewDesktop || this.slidesPerViewDesktop >= this.productsToShow) this.slidesPerViewDesktop = 'auto';
  }

  init() {
    const gridSliderWrapper = this.closest('[data-grid-slider-wrapper]');
    const scrollbarElement = gridSliderWrapper?.querySelector('.swiper-scrollbar');
    const nextEl = gridSliderWrapper?.querySelector('.swiper-button--next');
    const prevEl = gridSliderWrapper?.querySelector('.swiper-button--prev');
    const gridSpacingMobile = parseInt(this.dataset.gridSpacingMobile, 10) || 15;
    const gridSpacingTablet = parseInt(this.dataset.gridSpacingTablet, 10) || gridSpacingMobile;
    const gridSpacingDesktop = parseInt(this.dataset.gridSpacingDesktop, 10) || 30;
    const centeredSlides = this.dataset.centeredSlides == 'true';
    const centeredSlidesMobile = this.dataset.centeredSlidesMobile ? this.dataset.centeredSlidesMobile == 'true' : centeredSlides;
    const loop = this.dataset.loop == 'true';
    const initialSlide = this.dataset.initialSlide || 0;
    const tabletBreakpoint = parseInt(this.dataset.breakpointTablet, 10) || 768;
    const desktopBreakpoint = parseInt(this.dataset.breakpointDesktop, 10) || tabletBreakpoint;
    const disableOnMobile = this.dataset.disableOnMobile == 'true';
    const disableOnDesktop = this.dataset.disableOnDesktop == 'true';
    const useTabletBreakpoint = this.dataset.slidesPerViewTablet != null || this.dataset.breakpointTablet != null || desktopBreakpoint !== tabletBreakpoint;

    // Disable slider on mobile or desktop based on settings and re-check on resize
    const handleResize = () => {
      const viewportWidth = window.innerWidth;

      if (viewportWidth < tabletBreakpoint && disableOnMobile) {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
        gridSliderWrapper?.classList.remove('swiper-initialized');
        return true;
      }
      if (viewportWidth >= desktopBreakpoint && disableOnDesktop) {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
        gridSliderWrapper?.classList.remove('swiper-initialized');
        return true;
      }
      return false;
    };

    // Run on init
    if (handleResize()) return;

    // Listen for resize
    if (!this._resizeListenerAdded) {
      this._resizeListenerAdded = true;
      window.addEventListener('resize', () => {
        if (handleResize()) return;
        // If slider was previously destroyed, re-init
        if (!this.swiperInstance) this.init();
      });
    }

    this.swiperInstance = new Swiper(this, {
      modules: [A11y, Navigation, Scrollbar, Mousewheel],
      spaceBetween: gridSpacingMobile,
      slidesPerView: this.slidesPerViewMobile,
      centeredSlides: centeredSlidesMobile,
      loop: loop,
      initialSlide: initialSlide,
      mousewheel: {
        enabled: true,
        releaseOnEdges: false,
        invert: false,
        forceToAxis: true,
        sensitivity: 1,
        eventsTarget: 'container',
        thresholdDelta: null,
        thresholdTime: null,
        noMousewheelClass: 'swiper-no-mousewheel'
      },
      navigation: { prevEl, nextEl },
      scrollbar: { el: scrollbarElement, draggable: true },
      on: {
        init: () => gridSliderWrapper?.classList.add('swiper-initialized'),
      },
      breakpoints: useTabletBreakpoint
        ? {
            [tabletBreakpoint]: { spaceBetween: gridSpacingTablet, slidesPerView: this.slidesPerViewTablet, centeredSlides: centeredSlides },
            [desktopBreakpoint]: { spaceBetween: gridSpacingDesktop, slidesPerView: this.slidesPerViewDesktop, centeredSlides: centeredSlides }
          }
        : {
            768: { spaceBetween: gridSpacingDesktop, slidesPerView: this.slidesPerViewDesktop, centeredSlides: centeredSlides }
          },
      watchOverflow: true,
    });
  }
}

if (!customElements.get('grid-slider')) customElements.define('grid-slider', GridSlider);


};

if (window.T3SwiperRuntime?.Swiper) {
  __initWithSharedSwiper();
} else {
  window.addEventListener('t3:swiper-runtime:ready', __initWithSharedSwiper, { once: true });
}
/******/ })()
;
